import { Badge, BadgeProps } from '@mui/material';
import { Component, PropsWithChildren, ReactNode } from 'react';
import { WithStyles, createStyles, withStyles } from '@mui/styles';

const styles = () =>
    createStyles({
        badgeRoot: {
            flexDirection: 'row-reverse',
            alignItems: 'center',
        },
        badge: {
            top: 0,
            right: 0,
            position: 'relative',
            transform: 'none',
            minWidth: 24,
            minHeight: 24,
            borderRadius: 12,
            fontWeight: 600,
        },
    });

interface PoolBadgeProps extends Omit<BadgeProps, 'content' | 'classes'>, WithStyles<typeof styles> {
    content?: ReactNode;
    max?: number;
}

export const PoolBadge = withStyles(styles)(
    class PoolBadgeBase extends Component<PropsWithChildren<PoolBadgeProps>> {
        public override render() {
            const { classes, content, children, max, color = 'primary', ...badgeProps } = this.props;

            if (!content) {
                return this.props.children || null;
            }

            return (
                <Badge
                    classes={{
                        root: classes.badgeRoot,
                        badge: classes.badge,
                    }}
                    color={color}
                    badgeContent={content}
                    max={max || Number.MAX_VALUE}
                    {...badgeProps}
                >
                    {children}
                </Badge>
            );
        }
    }
);
